import { type FC } from "react";

import type { Entity } from "../../../../core/types/fe";
import type { ExtendedColumnsType } from "../../../index";
import { PropertyTable } from "../../../Table/components/PropertyTable";
import type { AntCustomFormField } from "../../types/types";

interface SimpleTerminal extends Entity {
    terminalId: string;
}

export interface CampaignTerminalsViewTableProps extends AntCustomFormField<string[]> {}

const getColumnsConfig = (t: Function): ExtendedColumnsType<SimpleTerminal>[] => {
    return [
        {
            title: t("terminal.terminalId"),
            key: "terminalId",
            dataIndex: "terminalId",
        },
    ];
};

/**
 * Simple terminals table with selection functionality.
 * Displays terminal IDs from value.terminalIdList and allows selection with checkboxes.
 */
export const CampaignTerminalsViewTable: FC<CampaignTerminalsViewTableProps> = ({ value, onChange }) => {
    const tableData = (value ?? []).map((terminalId) => ({
        id: terminalId,
        terminalId,
    }));

    const handleSelectionChange = (selectedTerminals: SimpleTerminal[]) => {
        if (onChange) {
            const selectedIds = selectedTerminals.map((terminal) => terminal.terminalId);
            onChange(selectedIds);
        }
    };

    return (
        <PropertyTable<SimpleTerminal>
            name="campaignTerminalsView_table"
            getColumnsConfig={getColumnsConfig}
            propertyAsRowKey="terminalId"
            readOnly
            rowsAreSelectable={false}
            tableData={tableData}
            onDataChanged={handleSelectionChange}
        />
    );
};
